export interface IDetailedResponse {
    success: boolean;
    errors: [{}];
}

export class DetailedResponse implements IDetailedResponse {
    success: boolean;
    errors: [{}];

    constructor(obj: DetailedResponse | any) {
        Object.assign(this, obj);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/settings/shared/models/detailed-response.model.ts